<script setup lang="ts">
import { RestaurantAreas, RestaurantLiteWithDistance } from '~/lib/interfaces/restaurant'
import { Restaurant } from '~/lib/services/store/restaurant/restaurant.dto'
const { trackSelectRestaurant } = useGTM()
const authStore = useAuthStore()
const countryCode = useCountry()
const { restaurantServiceRef } = useStoreService()
const restaurantService = restaurantServiceRef()
const restaurantActions = useRestaurantActions()

const latestRestaurants = authStore.userMcId
  ? getLatestRestaurants({
      userMcId: authStore.userMcId,
      userCountry: countryCode,
    })
  : []

const selectedRestaurant = ref<RestaurantLiteWithDistance>()

const setRestaurant = (restaurant: RestaurantLiteWithDistance) => {
  selectedRestaurant.value = restaurant
}

watch(selectedRestaurant, async newRestaurant => {
  if (newRestaurant) {
    const restaurantCode = newRestaurant.code
    let restaurantDetail: Restaurant | undefined
    try {
      restaurantDetail = await restaurantService.getStoreRestaurantByCode({
        countryCode,
        area: RestaurantAreas.MOP,
        restaurantCode,
      })
    } catch (error) {
      return
    }
    trackSelectRestaurant(restaurantCode)
    await restaurantActions.setRestaurant(restaurantDetail)
    selectedRestaurant.value = undefined
  }
})
</script>

<template>
  <div class="mt-6 flex flex-col">
    <template v-for="restaurant in latestRestaurants" :key="restaurant.id">
      <div
        class="flex w-full cursor-pointer gap-[37px] px-4 md:px-14"
        :class="selectedRestaurant?.id === restaurant.id ? 'bg-mcd-secondaryIvory' : 'white'"
      >
        <img
          class="hidden md:block"
          :src="
            selectedRestaurant?.id === restaurant.id
              ? '/images/icons/radioButtonChecked.svg'
              : '/images/icons/radioButton.svg'
          "
          alt="radio button"
          @click="setRestaurant(restaurant)"
        />

        <div class="flex w-full items-start gap-4 py-4" @click="setRestaurant(restaurant)">
          <img
            v-if="restaurant?.isFavorite"
            class="h-auto w-4"
            src="/images/icons/favoriteFilled.svg"
            alt="favorite icon"
          />
          <img v-else src="/images/icons/reorder.svg" class="h-auto w-4" alt="reorder icon" />
          <div class="flex w-full flex-col gap-1">
            <RestaurantName
              small-font
              :name="restaurant.name"
              :city="restaurant.city"
              :show-if-favorite="false"
              :restaurant-code="restaurant.code"
            />
            <RestaurantDirection
              small-font
              :address="restaurant.address"
              :city="restaurant.city"
              :distance="restaurant.distance"
            />
            <RestaurantState :restaurant="restaurant" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
